var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagSelector',{attrs:{"items":_vm.qbClasses,"value":_vm.value ? _vm.value.qb_class_id : null,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }